<script>
    import {error} from "./stores.js"
    import axios from "axios"
    export let onReset;
    export let video = ""


    $:{
        console.log("vv",video)
    }
    export let yeets = {
        "Single": {
            "cat": "https://files.catbox.moe/nmn0hn.webm",
            "cat2": "https://files.catbox.moe/higlar.webm",
        },
        "Replace Me": {
            "one": "https://s1.webmshare.com/LxKgL.webm",
            "two": "https://s1.webmshare.com/rVWre.webm",
            "three": "https://s1.webmshare.com/LxKgL.webm",
        },
        "Triplets": {
            "seven": "https://i.imgur.com/aPVsxAg.mp4",
            "eight": "https://i.imgur.com/qwO5SR4.mp4",
            "f": "https://i.imgur.com/hg5nLQi.mp4"
        }
    }

    function parseConfig(inp) {
        let tokens = inp.split("\n")
        let res = {}

        let categoryName = ""
        let videos = {}
        tokens.forEach((t, i) => {
            if(i === tokens.length-1) if(categoryName !== "") res[categoryName] = videos
            if(t === "") return
            t = t.trim()
            if(t.substring(0, 1) === "="){
                if(categoryName !== "") res[categoryName] = videos
                // clear
                videos = {}
                categoryName = t.substring(1,t.length).trim()
                return
            }
            let sp = t.split("=")
            let videoName = sp[0].trim()
            let videoLink = sp[1].trim()
            if(videoName === null || videoName === "" || videoName === undefined) return;
            videos[videoName] = videoLink
        })
        return res
    }

    axios.get(`./config.txt?ts=${Date.now()}`)
        .then(function (response) {
            // handle success
            console.log(response)
            console.log(response.data, typeof response.data)
            yeets = parseConfig(response.data)
        })
        .catch(function (e) {
            // handle error
            $error = e.stack
            $error = $error + (typeof e)
            console.log(e.stack, {e})
        })
        .then(function () {
            // always executed
        });

    function reset() {
        onReset();
    }
    function screenshot(scaleFactor) {
        let videoElement = document.querySelectorAll(`[data-current-video="true"]`)[0]

        videoElement.setAttribute('crossOrigin', 'Anonymous')
        console.log(videoElement)
        videoElement.pause()
        displayLink = "..."
        setTimeout(() => {
            scaleFactor = 1;
            let w = videoElement.videoWidth * scaleFactor
            let h = videoElement.videoHeight * scaleFactor
            let canvas = document.getElementById("canvas-container").children[0]
            if(canvas == null) {
                canvas = document.createElement("canvas")
                document.getElementById("canvas-container").appendChild(canvas)
            }
            canvas.setAttribute('crossOrigin', 'Anonymous')
            canvas.style.position = "absolute";
            canvas.style.zIndex = "-50";
            canvas.style.opacity = "0";
            canvas.style.top = "0";
            canvas.style.left = "0";

            //     canvas {
            //     position: absolute;
            //     top: 0;
            //     left: 0;
            //     z-index: -50;
            //     opacity:0;
            // }
            canvas.width = w;
            canvas.height = h;
            let ctx = canvas.getContext('2d');
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(videoElement, 0, 0, w, h);

            console.log("cvs",canvas)

            let dataURI = canvas.toDataURL()


            const formData = new FormData();

            formData.append("file", dataURI);
            formData.append("upload_preset", "qx6chvs2");

            console.log("Fetching ..")
            fetch("https://api.cloudinary.com/v1_1/dv8cvkn07/image/upload", {
                method: "POST",
                body: formData
            })
                .then((response) => {
                    return response.json();
                })
                .then((data) => {
                    console.log("got some data", data)
                    displayLink = data.url
                }).catch((data)=>{
                console.log("got some error", data)
                displayLink = data
            }).finally(() => {
                console.log("finally!")
                setTimeout(() => {
                    videoElement.play()
                }, 1000)
            })
        }, 250)

    }
    let displayLink = ""
    let copyBtnText = "Copy Full Img Link"

    function copyToClipboard(){
        var copyText = document.getElementById("ta");
        copyText.value = displayLink
        copyText.select();
        document.execCommand("copy");

        copyBtnText = "Copied!"
        setTimeout(() => {
            copyBtnText = "Copy Full Img Link"
        }, 1000)

    }
</script>

<div class="parent">
    <div id="canvas-container">

    </div>
    <span class="title" style="">Patients cannot see this secret menu.</span>
    <br>
    <span class="subTitle" on:click={reset}>Clear Video</span>
    <span class="subTitle" on:click={screenshot}>Take Screenshot</span>

    <p style="width:200px" class="link">{displayLink}</p>
    {#if displayLink !== ""}
        <span class="subTitle" on:click={()=>{copyToClipboard()}}>{copyBtnText}</span>
        <span class="subTitle" on:click={()=>{displayLink = ""}}>Clear Img Link</span>
    {/if}
    <br>
    {#each Object.entries(yeets) as obj}
        <span class="title">{obj[0]}</span>
        {#each Object.entries(obj[1]) as thingy, i}
            <span class="subTitle"
                  on:click={() => {
                        video = thingy[1];
                        setTimeout(()=> {document.querySelectorAll(`[data-current-video="true"]`)[0].play();}, 50)
                        console.log("chaned", thingy[1])}
                    }>{thingy[0]}</span>
        {/each}
    {/each}
    <textarea style="opacity:0" readonly id="ta" cols=15 rows=1></textarea>
</div>

<style>
    .link {
        color:white;
        background-color: rgba(0,0,0,0.5);
        padding: 8px;
    }
    .parent {
        height:600px;
        overflow-y: scroll;
        overflow-x: hidden;
    }
    .title, .subTitle{
        display:block;
        color:white;
        padding: 0.3rem;
        margin-right: 0;
    }
    .title {
        font-weight: bold;
        box-shadow: 5px 0 15px midnightblue inset, 0 1px 2px white;;
        background: linear-gradient(90deg, rgb(32, 57, 149) 0%, rgba(32,32,134,0) 100%);
        margin-top: 1rem;
    }
    .subTitle {
        margin-left: 1rem;
        margin-top: 0.25rem;
        padding: 0.25rem;
        cursor:pointer;
        box-shadow: 5px 0 15px midnightblue inset, 0 1px 2px white;
    }
    .subTitle:hover {
        color: darkblue;
        background: linear-gradient(90deg, rgb(255, 255, 255) 0%, rgba(32,32,134,0) 100%);
        box-shadow: 5px 0 15px midnightblue inset, 0 1px 2px midnightblue;
    }
</style>
